// extracted by mini-css-extract-plugin
export default {"form":"form_form__35LV2","header":"form_header__LfVbE","wrapper":"form_wrapper__GUb9i","checkboxLabel":"form_checkboxLabel__cAaKN","error":"form_error__yoSc5"};